var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Add Advocate",
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: true,
        centered: ""
      },
      on: { ok: _vm.addAdvocate, hide: _vm.modalClose },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary", size: "sm" },
                  on: { click: _vm.modalClose }
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: { click: _vm.addAdvocate }
                },
                [_vm._v("\n        Submit\n      ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-form",
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Advocate Name",
                "label-class": "addpersonlabel",
                "label-for": "Advocate Name"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { size: "lg", type: "text", name: "Advocate Name" },
                model: {
                  value: _vm.advocate.name,
                  callback: function($$v) {
                    _vm.$set(_vm.advocate, "name", $$v)
                  },
                  expression: "advocate.name"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.inputValidationErrors.has("Advocate Name"),
                      expression: "inputValidationErrors.has('Advocate Name')"
                    }
                  ],
                  staticClass: "text-info"
                },
                [
                  _vm._v(
                    _vm._s(_vm.inputValidationErrors.first("Advocate Name"))
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Organization",
                "label-class": "addpersonlabel",
                "label-for": "Organization"
              }
            },
            [
              _c("b-form-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "organization",
                  "data-vv-name": "Organization",
                  "data-vv-as": "Organization",
                  options: _vm.organizationOptions
                },
                model: {
                  value: _vm.advocate.organization,
                  callback: function($$v) {
                    _vm.$set(_vm.advocate, "organization", $$v)
                  },
                  expression: "advocate.organization"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.inputValidationErrors.has("Organization"),
                      expression: "inputValidationErrors.has('Organization')"
                    }
                  ],
                  staticClass: "text-info"
                },
                [
                  _vm._v(
                    _vm._s(_vm.inputValidationErrors.first("Organization"))
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.advocate.organization === "Other"
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Other Organization",
                    "label-for": "Other Organization"
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      size: "lg",
                      type: "text",
                      name: "Other Organization"
                    },
                    model: {
                      value: _vm.advocate.organization_otherText,
                      callback: function($$v) {
                        _vm.$set(_vm.advocate, "organization_otherText", $$v)
                      },
                      expression: "advocate.organization_otherText"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "Other Organization"
                          ),
                          expression:
                            "inputValidationErrors.has('Other Organization')"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first("Other Organization")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Email",
                "label-class": "addpersonlabel",
                "label-for": "Email"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { size: "lg", type: "text", name: "Email" },
                model: {
                  value: _vm.advocate.email,
                  callback: function($$v) {
                    _vm.$set(_vm.advocate, "email", $$v)
                  },
                  expression: "advocate.email"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.inputValidationErrors.has("Email"),
                      expression: "inputValidationErrors.has('Email')"
                    }
                  ],
                  staticClass: "text-info"
                },
                [_vm._v(_vm._s(_vm.inputValidationErrors.first("Email")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Phone",
                "label-class": "addpersonlabel",
                "label-for": "phone"
              }
            },
            [
              _c("b-form-input", {
                attrs: { size: "lg", type: "text", name: "phone" },
                model: {
                  value: _vm.advocate.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.advocate, "phone", $$v)
                  },
                  expression: "advocate.phone"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af72ae2e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af72ae2e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/AddAdvocateModal.vue
// module id = 1567
// module chunks = 0